module.exports = __webpack_public_path__ + "static/media/logoApp.73fa92c3.png";